import { MIN_FIELD_WIDTH } from './CollectionTemplateTable'

export type CollectionTemplateTableCellProps = {
  coordinates: { x: number, y: number }
  config?: any | null
}

export function CollectionTemplateTableCell (props: CollectionTemplateTableCellProps) {
  const { coordinates, config } = props

  const configuredWidth = config?.ui?.width ? (config?.ui?.width - 40) : MIN_FIELD_WIDTH
  const width = configuredWidth < MIN_FIELD_WIDTH
    ? MIN_FIELD_WIDTH
    : configuredWidth

  return (
    <div
      id={`cell-${coordinates.x}-${coordinates.y}`}
      className="border-r border-neutral/40 flex items-start content-stretch relative overflow-x-hidden cursor-pointer"
      style={{ width }}
    />
  )
}
